type ChevronRightIconProps = {
  size?: number
}

export function ChevronRightIcon({ size = 24 }: ChevronRightIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M6.71975 17.5303C7.01259 17.8231 7.48739 17.823 7.7803 17.5303L14.7803 10.5303C15.0732 10.2374 15.0732 9.76262 14.7803 9.46973L7.7803 2.46973C7.4874 2.17683 7.01264 2.17683 6.71975 2.46973C6.42701 2.76263 6.42691 3.23743 6.71975 3.53027L13.1895 10L6.71975 16.4697C6.42701 16.7626 6.42691 17.2374 6.71975 17.5303Z" fill="currentColor" />
    </svg>
  )
}
